import { tzAxios } from 'api/axios';
import { SingleOrderRequest } from 'api/requestTypes';
import { orderNumber, SingleOrderResponse } from 'api/responseTypes';

export const sendOrder = async (data: SingleOrderResponse) =>
  (await tzAxios.post<SingleOrderRequest>(`/ticket-zone/checkout`, data)).data;

export const sendOrderNumber = async (data: orderNumber) =>
  (await tzAxios.post(`/ticket-zone/ticket-orders/purchase/callback/qiservices`, data)).data;
